/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

const PermitSearchInput = (props) => {
    const onChangeHandler = props?.onChangeHandler;
    const onSelectOption = props?.onSelectOption;
    const placeholder = props?.placeholder;
    const resetFetch = props?.resetFetch;
    const queryValue = props?.queryValue;
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState(queryValue);

    const handleInputChange = (event, value) => {
        setInputValue(value);
        if (value.trim() !== "" && value?.length > 2) {
            setLoading(true);
            (async () => {
                const _options = await onChangeHandler(value);
                setLoading(false);
                if (event?.type === "change") {
                    setOptions([..._options]);
                }
            })();
        } else {
            setOptions([]);
        }
    };

    const onChange = (event, value) => {
        onSelectOption(value);
    };

    const handleClose = () => {
        setOptions([]);
        setLoading(false);
    };

    const onClear = () => {
        resetFetch();
    };

    useEffect(() => {
        setInputValue(queryValue);
    }, [queryValue]);

    const customStyle = {
        width: 424,
        "& .MuiInputBase-root": { height: 48 },
        "& .MuiOutlinedInput-root": { height: 48 },
        "& .MuiAutocomplete-input": {
            height: 48,
            padding: "0 14px",
        },
        "& .MuiAutocomplete-option": {
            minHeight: 48,
            display: "flex",
            alignItems: "center",
        },
    };

    return (
        <Autocomplete
            freeSolo
            clearOnBlur={false}
            inputValue={inputValue}
            sx={customStyle}
            open={inputValue !== "" && options.length > 0}
            onInputChange={handleInputChange}
            onChange={onChange}
            onClose={handleClose}
            popupIcon={null}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option.label}
            options={options}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    placeholder={placeholder}
                />
            )}
            componentsProps={{
                clearIndicator: {
                    onClick: onClear,
                },
            }}
        />
    );
};

export { PermitSearchInput };
